// extracted by mini-css-extract-plugin
var _1 = "amFc80ed";
var _2 = "gFnfx4ij";
var _3 = "VSpKMDvI";
export { _1 as "confirmBtn", _2 as "message", _3 as "text" }
